import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { Indicator } from '../../models/dashboard.model';
import { Point } from '../../models/pointWidget.model';
import { QFilterModel } from '../../models/qfilter.model';
import { LoyaltyChart, LoyaltySankeyChart } from '../../models/loyalty-chart-config.model';
import { TranslateService } from '@ngx-translate/core';
import { CustomerFairShareRowModel, CustomerPointsRowModel } from '../../models/customer-points-row.model';
import { IndicatorOtherModel } from '../../models/indicator-box.model';

@Injectable()
export class IndicatorsService {

  constructor (
    private http: HttpClientService
  ) { }

  /**
   * Restituisce nomi e valori degli indicatori
   * @param name
   * @param data
   */
  indicatorCalculation(name: string, data: any): Observable<any> {
    return this.http.post(HttpClientService.BASE_MS_ANALYTICS + '/analytics/getIndicator/' + name, data);
  }

  /**
   * Restituisce dati per schema ad Albero
   * @param name
   * @param data
   */
  indicatorCalculationOther(name: string, data: any): Observable<Array<IndicatorOtherModel>> {
    return this.http.post(HttpClientService.BASE_MS_ANALYTICS + '/analytics/getIndicatorOther/' + name, data);
  }

  /**
   * Restituisce serie di dati per i grafici
   * @param name
   * @param body
   * @param isPivot
   * @param queryParam
   * @param isTranspose
   */
  getChart(name: string, body: any, isPivot = false, queryParam = '', isTranspose = false): Observable<any> {
    const url = HttpClientService.BASE_MS_ANALYTICS
        + '/analytics/getDataSerie'
        + (isPivot ? 'Pivot' : '')
        + (isTranspose ? 'Transpose' : '')
        + '/' + name + queryParam;
    return this.http.post(url, body);
  }

  getWidgetsPoint(data: any): Observable<Array<Point>> {
    return this.http.post(HttpClientService.BASE_MS_ANALYTICS + '/overview/getIndicator/ValorePunti', data);
  }

  /**
   * Restituisce il periodo di riferimento
   * @param subject
   */
  getReferenceDates(subject: string): Observable<any> {
    return this.http.get(HttpClientService.BASE_MS_ANALYTICS + '/analytics/getReferenceDates/' + subject);
  }

  getFairShareTable(queryName: string, filter: QFilterModel): Observable<CustomerFairShareRowModel[]> {
    return new Observable((observer) => {
      this.getChart(queryName, filter).subscribe((resp) => {
        const res = resp.series;

        const datatable: CustomerFairShareRowModel[] = [];

        if (res.length > 0 && res[0].serie.length > 0) {
          console.log('descrizione', res.find(dati => dati.titolo === 'descrizione_livello_merc').serie);

          const descrizione_categoria = res.find(dati => dati.titolo === 'descrizione_livello_merc').serie;
          const revenues_sel = res.find(dati => dati.titolo === 'revenues_sel').serie;
          const inc_sel_su_card = res.find(dati => dati.titolo === 'inc_sel_su_card').serie;
          const battuta_media_sel = res.find(dati => dati.titolo === 'battuta_media_sel').serie;
          const battuta_media_card = res.find(dati => dati.titolo === 'battuta_media_card').serie;
          const delta_battuta_media = res.find(dati => dati.titolo === 'delta_battuta_media').serie;
          const prc_speso_categ_selezionati = res.find(dati => dati.titolo === 'prc_speso_categ_selezionati').serie;
          const prc_speso_categ_cardisti = res.find(dati => dati.titolo === 'prc_speso_categ_cardisti').serie;
          const delta_prc_speso = res.find(dati => dati.titolo === 'delta_prc_speso').serie;

          for (let i = 0; i < res[0].serie.length; i++) {

            const row: CustomerFairShareRowModel = {
              descrizione_categoria: descrizione_categoria[i],
              revenues_sel: revenues_sel[i],
              inc_sel_su_card: inc_sel_su_card[i],
              battuta_media_sel: battuta_media_sel[i],
              battuta_media_card: battuta_media_card[i],
              delta_battuta_media: delta_battuta_media[i],
              prc_speso_categ_selezionati: prc_speso_categ_selezionati[i],
              prc_speso_categ_cardisti: prc_speso_categ_cardisti[i],
              delta_prc_speso: delta_prc_speso[i],
            };

            datatable.push(row);
          }
        }

        observer.next(datatable);
      });
    });
  }

  getCustomersPointsTable(queryName: string, filter: QFilterModel, titoloSerie: string ): Observable<CustomerPointsRowModel[]> {
    return new Observable((observer) => {
      this.getChart(queryName, filter).subscribe((resp) => {
        const res = resp.series;

        const datatable: CustomerPointsRowModel[] = [];

        const sumRow: CustomerPointsRowModel = {
          meccanica: 'Total',
          pt_corr: 0,
          pt_prec: 0,
          pt_delta: 0,
          erog_corr: 0,
          erog_prec: 0,
          erog_delta: 0
        };

        if (res.length > 0 && res[0].serie.length > 0) {
          console.log('descrizione', res.find(dati => dati.titolo === titoloSerie).serie);


          const descrizione_accumulo = res.find(dati => dati.titolo === titoloSerie).serie;
          const n_pti_corr = res.find(dati => dati.titolo === 'n_pti_corr').serie;
          const n_pti_pre = res.find(dati => dati.titolo === 'n_pti_pre').serie;
          const n_erog_corr = res.find(dati => dati.titolo === 'n_erog_corr').serie;
          const n_erog_pre = res.find(dati => dati.titolo === 'n_erog_pre').serie;

          for (let i = 0; i < res[0].serie.length; i++) {

            const row = {
              meccanica: descrizione_accumulo[i],
              pt_corr: n_pti_corr[i],
              pt_prec: n_pti_pre[i],

              pt_delta: IndicatorsChartService.deltaPercentage(n_pti_pre[i], n_pti_corr[i]),

              erog_corr: n_erog_corr[i],
              erog_prec: n_erog_pre[i],

              erog_delta: IndicatorsChartService.deltaPercentage(
                res.find(dati => dati.titolo === 'n_erog_pre').serie[i], res.find(dati => dati.titolo === 'n_erog_corr').serie[i]),
            };

            sumRow.pt_corr += row.pt_corr;
            sumRow.pt_prec += row.pt_prec;
            sumRow.erog_corr += row.erog_corr;
            sumRow.erog_prec += row.erog_prec;

            datatable.push(row);
          }

          sumRow.pt_delta = IndicatorsChartService.deltaPercentage(sumRow.pt_prec, sumRow.pt_corr);
          sumRow.erog_delta = IndicatorsChartService.deltaPercentage(sumRow.erog_prec, sumRow.erog_corr);
        }

        datatable.push(sumRow);

        observer.next(datatable);

      });
    });
  }



  /*********** INUTILI ***************/

  // Richiamata solo in IndicatorComponent, il quale sembra non piú utilizzato
  getGeneralIndicator(nameIndicator: string): Observable<Indicator> {
    return this.http.get(HttpClientService.BASE_MS_ANALYTICS + '/analytics/getIndicator/' + nameIndicator);
  }

  // Mai richiamata
  getStoreInfo(storeId: number): Observable<any> {
    return this.http.get(HttpClientService.BASE_MS_ANALYTICS + '/analytics/store/' + storeId);
  }

  // Richiamata solo in Negozi > Analisi Negozio > Tab Panoramica, il quale, però, risulta non attivabile
  getStorePost(data: any): Observable<any> {
    return this.http.post(HttpClientService.BASE_MS_ANALYTICS + '/analytics/store/', data);
  }

}

@Injectable()
export class IndicatorsChartService {

  public static deltaPercentage(prec: number, current: number) {
    return ((current - prec) / prec) * 100;
  }

  constructor() {}

  public loadBubbleChart(
    chartInstance: LoyaltyChart,
    queryName: string,
    qFilter: QFilterModel,
    indicatorService: IndicatorsService,
    translation: any
  ) {

    indicatorService.getChart(queryName, qFilter, false).subscribe(res => {

      if (!translation) {
        translation = {
          chart_serie_title: 'No Name Serie',
          previous: 'Prev.',
          actual: 'Act.',
        }
      }

      if (res.series.length < 4) {
        return;
      }

      if (chartInstance.instance) {
        while (chartInstance.instance.series.length > 0) {
          chartInstance.instance.series[0].remove(true);
        }
      }

      const data_act = [];
      const data_prev = [];

      for (let i = 0; i < res.series[0].serie.length; i++) {
        data_act.push({ x: res.series[2].serie[i], y: res.series[1].serie[i], z: res.series[3].serie[i], name: res.series[0].serie[i] });
        data_prev.push({ x: res.series[5].serie[i], y: res.series[4].serie[i], z: res.series[6].serie[i], name: res.series[0].serie[i] });
      }

      chartInstance.instance.addSeries(
        {
          name: translation.chart_serie_title + ` (${translation.previous})`,
          data: data_prev,
          color: LoyaltyChart.colors[21]
        }
      );

      chartInstance.instance.addSeries(
        {
          name: translation.chart_serie_title + ` (${translation.actual})`,
          data: data_act,
          color: LoyaltyChart.colors[1]
        }
      );


      chartInstance.instance.update(chartInstance.options);
      chartInstance.instance.redraw();

    });

  }

  public loadSankeyChart(
    chartInstance: LoyaltySankeyChart,
    queryName: string,
    qFilter: QFilterModel,
    indicatorService: IndicatorsService,
    translate: TranslateService = null,
    queryParam = ''
  ) {
    indicatorService.getChart(queryName, qFilter, false, queryParam).subscribe(res => {

      if (res.series.length < 5) {
        return;
      }

      const data = [];
      const nodes: { id: string, color: string }[] = [];

      for (let i = 0; i < res.series[0].serie.length; i++) {
        data.push([ res.series[0].serie[i], res.series[2].serie[i] + ' ', res.series[4].serie[i] ]);

        if ( !nodes.find(node => ((node.id === res.series[0].serie[i]) || node.id === (res.series[0].serie[i] + ' '))) )  {
          nodes.push({
            id: res.series[0].serie[i],
            color: res.series[1].serie[i]
          });

          nodes.push({
            id: res.series[0].serie[i] + ' ',
            color: res.series[1].serie[i]
          });
        }

        if ( !nodes.find(node => ((node.id === res.series[2].serie[i]) || node.id === (res.series[2].serie[i] + ' '))) )  {
          nodes.push({
            id: res.series[2].serie[i],
            color: res.series[3].serie[i]
          });

          nodes.push({
            id: res.series[2].serie[i] + ' ',
            color: res.series[3].serie[i]
          });
        }
      }

      const options = {
        series: [{
          keys: ['from', 'to', 'weight'],
          data: data,
          nodes: nodes,
          type: 'sankey'
        }]
      };

      chartInstance.instance.update(options);
      chartInstance.instance.redraw();
    });
  }

  public loadChart(chartInstance: LoyaltyChart,
                   queryName: string,
                   qFilter: QFilterModel,
                   indicatorService: IndicatorsService,
                   translate: TranslateService = null,
                   isPivot = false,
                   colors = LoyaltyChart.colors,
                   tkey_prefix = 'loyalty_chart'
  ) {
    indicatorService.getChart(queryName, qFilter, isPivot).subscribe(res => {

      const xAxis = res.series[0];
      const series = [];

      for (let i = 1; i < res.series.length; i++) {
        series.push(res.series[i]);
      }

      return this.loadChartBase(
        chartInstance,
        xAxis,
        series,
        translate,
        colors,
        tkey_prefix
      );
    });
  }

  public loadChartBase(chartInstance: LoyaltyChart, xAxis: any, series: any[], translate: TranslateService = null, colors, tkey_prevfix) {
    if (chartInstance.instance) {
      while (chartInstance.instance.series.length > 0) {
        chartInstance.instance.series[0].remove(true);
      }
    }

    chartInstance.options.xAxis.categories = xAxis.serie;

    for (let i = 0; i < series.length; i++) {
      let titolo = series[i].titolo;

      if (translate != null) {
        let title = tkey_prevfix + '.' + series[i].titolo;
        if (tkey_prevfix == '') {
          title = series[i].titolo;
        }
        translate.get([title]).subscribe(t => {
          titolo = t[title];
        });
      }

      chartInstance.instance.addSeries({
        name: titolo,
        color: colors[i],
        data: this.buildSerie(series[i].serie, titolo)
      });
    }

    chartInstance.instance.update(chartInstance.options);
    chartInstance.instance.redraw();
  }

  /**
   * Utility for Build a Chart Serie
   * @param {Array<any>} serie
   * @param {string} titolo
   * @returns {any[]}
   */
  public buildSerie(serie: Array<any>, titolo: string) {
    const output = [];

    serie.forEach(data => {
      output.push({
        name: titolo,
        y: +data
      });
    });

    return output;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/indicators/indicators.service.ts